export default __webpack_public_path__ + "static/media/visalogo.cbde840c.svg";